// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* container centers everything */
.landing-container {
  max-width: 960px;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #333;
  gap: 0px;
}

/* header styling */
.landing-header h1 {
  font-size: 2.25rem;
  margin-bottom: 16px;
  font-weight: 700;
  color: #FFF;
} 

.landing-header p {
  font-size: 1rem;
  margin-bottom: 40px;
  color: #888;
}

/* steps grid */
.steps-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  margin-bottom: 40px;
}

/* individual card */
.step-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.step-header {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 12px;
}

.step-text {
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 16px;
  color: #444;
}

.step-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

/* QR wrapper to center the component */
.qr-wrapper {
  display: flex;
  justify-content: center;
}
.qr-component {
  width: 200px;  /* or adjust as needed */
  height: auto;
}

/* moved button */
.install-button-wrapper {
  margin-top: 12px;
}

.learn-more-button {
  display: inline-block;
  background-color: #FFD000;
  color: #000;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 4px;
  text-decoration: none;
  transition: transform 0.1s ease;
}

.learn-more-button:hover {
  transform: scale(1.03);
}

/* responsive tweaks */
@media (max-width: 600px) {
  .landing-header h1 {
    font-size: 1.75rem;
  }
  .steps-container {
    gap: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/landing-qr.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sEAAsE;EACtE,WAAW;EACX,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY,GAAG,wBAAwB;EACvC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;AACF","sourcesContent":["/* container centers everything */\n.landing-container {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 60px 20px;\n  text-align: center;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: #333;\n  gap: 0px;\n}\n\n/* header styling */\n.landing-header h1 {\n  font-size: 2.25rem;\n  margin-bottom: 16px;\n  font-weight: 700;\n  color: #FFF;\n} \n\n.landing-header p {\n  font-size: 1rem;\n  margin-bottom: 40px;\n  color: #888;\n}\n\n/* steps grid */\n.steps-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 32px;\n  margin-bottom: 40px;\n}\n\n/* individual card */\n.step-card {\n  background: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n}\n\n.step-header {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.step-text {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin-bottom: 16px;\n  color: #444;\n}\n\n.step-image {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n/* QR wrapper to center the component */\n.qr-wrapper {\n  display: flex;\n  justify-content: center;\n}\n.qr-component {\n  width: 200px;  /* or adjust as needed */\n  height: auto;\n}\n\n/* moved button */\n.install-button-wrapper {\n  margin-top: 12px;\n}\n\n.learn-more-button {\n  display: inline-block;\n  background-color: #FFD000;\n  color: #000;\n  padding: 12px 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 4px;\n  text-decoration: none;\n  transition: transform 0.1s ease;\n}\n\n.learn-more-button:hover {\n  transform: scale(1.03);\n}\n\n/* responsive tweaks */\n@media (max-width: 600px) {\n  .landing-header h1 {\n    font-size: 1.75rem;\n  }\n  .steps-container {\n    gap: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
